import React, { useState, useEffect, useRef } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import { newsLetterBg } from '../../../../assets/images';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AppDialogBox from '../../../pages/AppDialogBox';
import {
  billingForm,
  emailOTPForm,
  orderNote,
  validatePhoneNo,
} from '../../../../utils/formElements';
import renderElements from '../../../../utils/renderElements';
import { appExtraFunctions } from '../../../../store/actions/AppActions';
import { toast } from 'react-toastify';
import { submitForm } from '../../../../store/actions/AuthActions';
import { submitData } from '../../../../ApiServices/AuthServices';
import { submitData as productSubmitData } from '../../../../ApiServices/ProductServices';
import { transportCharges as defaultTransportCharges } from '../../../../config/config';
import _ from 'lodash';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { appColor, convertTo12HourFormat, deliveryTimeSlots } from '../../../../utils/appConstants';
import { Alert } from '@mui/material';
import TermsAndConditions from '../../../layouts/Footer/TermsAndConditions';

import { Helmet } from 'react-helmet';

const Checkout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const steps = ['Billing Address', 'Validate', 'Place Order'];
  const halfWidthInputs = ['firstName', 'lastName', 'email', 'phone'];
  const paymentMethods = [
    // 'Cash on Delivery',
    'Online Payment',
  ];
  const myDivRef = useRef(null);

  const cartProducts = useSelector(state => state?.cart?.products);
  const billingValues = useSelector(state => state?.app?.billingValues);
  const user = useSelector(state => state?.auth?.user);
  const token = useSelector(state => state?.auth?.token);
  const btnLoaderOne = useSelector(state => state?.app?.btnLoaderOne);
  const orderActiveStep = useSelector(state => state?.app?.orderActiveStep) ?? 0;

  const [showDialog, setShowDialog] = useState(false);
  const [values, setValues] = useState({ country: 'India' });
  const [paymentMethod, setPaymentMethod] = useState();
  const [agreedTerm, setAgreedTerm] = useState(false);
  const [isAllDetailsFilled, setIsAllDetailsFilled] = useState(false);
  const [transportDays, setTransportDays] = useState(1);
  const [transportCharges, setTransportCharges] = useState();
  const [deliverySlots, setDeliverySlots] = useState();
  const [loading, setLoading] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [errorMsg, setErrorMsg] = useState('');
  const [isCataloguePurchase, setIsCataloguePurchase] = useState(false);
  const [emailOTP, setEmailOTP] = useState();
  useEffect(() => {
    if (!cartProducts || cartProducts?.length === 0) {
      navigate('/shop');
    } else if (cartProducts) {
      const allProducts = cartProducts
        ?.filter(p => p?.bufferingDays)
        ?.map(p => ({ ...p, days: p?.bufferingDays }));
      const groupByDays = _.groupBy(allProducts, 'days');
      setTransportDays(Object.keys(groupByDays)?.length);
    }

    if (cartProducts && cartProducts?.length == 1) {
      const selectedCategory = cartProducts?.[0]?.category;

      if (selectedCategory === 'Courses') {
        setIsCataloguePurchase(true);
        setTransportCharges(0);
        setPaymentMethod('Online Payment');
      }
    }
  }, [cartProducts]);

  useEffect(() => {
    if (billingValues) {
      setValues(billingValues);
    }

    dispatch(appExtraFunctions('saveActiveStep', 0));
  }, []);

  function handleTerms() {
    setShowDialog(true);
  }

  const handleSubmit = e => {
    e.preventDefault();
    // dispatch(signinAction(values, navigate));
    setIsAllDetailsFilled(true);
  };

  const handleChange = e => {
    const formValues = { ...values, [e?.target?.name]: e?.target?.value };
    setValues(formValues);
  };

  const handleBlur = e => {
    const formValues = { ...values, [e?.target?.name]: e?.target?.value };
    dispatch(appExtraFunctions('saveBillingValues', formValues));

    // setValues(formValues);
  };

  const handleOpenDialog = () => {
    setShowDialog(true);
  };

  const getOrderSubTotal = () => {
    const productsTotal = cartProducts?.reduce((a, b) => a + b?.price * b?.quantity, 0);
    const transportAmount = transportCharges * transportDays;
    return productsTotal + transportAmount;
  };

  const handlePaymentChoose = (e, method) => {
    setPaymentMethod(method);
  };

  const handleTimeSlotsChange = (e, slots) => {
    setDeliverySlots(slots);
  };

  const handlePlaceOrder = async () => {
    if (isCataloguePurchase) {
      if (values?.emailOTP != emailOTP) {
        toast.error('Incorrect Email OTP. Please try again.');
        return;
      }
    }

    let submitValues = {
      billingAddress: values,
      products: cartProducts,
      totalPrice: getOrderSubTotal(),
      paymentMethod,
      transportCharges,
      deliveryTimeSlots: deliverySlots,
      orderNote: values?.orderNote,
      isCataloguePurchase,
    };

    if (user) {
      submitValues = { ...submitValues, orderedBy: user };
    }

    if (paymentMethod === 'Cash on Delivery') {
      dispatch(submitForm('placeUserOrder', token, submitValues, '', navigate));
    } else if (paymentMethod === 'Online Payment') {
      dispatch(appExtraFunctions('btnLoaderOne', true));
      try {
        // Make a request to the backend to create the Razorpay order
        const response = await submitData('proceedPayment', token, submitValues);
        dispatch(appExtraFunctions('btnLoaderOne', false));
        const { id, currency, amount: orderAmount } = response?.data?.payload;

        const customerName = `${values?.firstName} ${values?.lastName ? values?.lastName : ''}`;

        // Setup Razorpay payment options
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          amount: orderAmount,
          currency,
          name: `SayCheeze payment from ${customerName}`,
          description: 'Payment for your product',
          order_id: id,
          method: 'UPI',
          handler: function (response) {
            const subValues = { razorPayPaymentDetails: response, submitValues };
            dispatch(submitForm('verifyOrderPayment', token, subValues, '', navigate));
          },
          prefill: {
            name: customerName,
            email: values?.email,
            contact: values?.phone,
          },
          notes: {
            address: values?.address,
          },
          theme: {
            color: '#b59410',
          },
        };

        // Open the Razorpay payment gateway
        const rzp1 = new window.Razorpay(options);
        rzp1.open();
      } catch (error) {
        dispatch(appExtraFunctions('btnLoaderOne', false));
        console.error('Error creating order:', error);
        navigate('/order/failed');
        dispatch(appExtraFunctions('saveActiveStep', 0));
      }
    }
  };

  const handleBillingAddressSubmit = async e => {
    e.preventDefault();

    const keysToCheck = billingForm.filter(f => f.required)?.map(f => f?.name);
    const checkValuesFilled = (obj, keys) => {
      return keys.every(
        key => obj[key] !== undefined && obj[key] !== null && obj[key].trim() !== ''
      );
    };

    const allFilled = checkValuesFilled(values, keysToCheck);

    if (!allFilled) {
      return toast.error('Please complete the Billing Address to proceed.');
    }

    if (values?.phone && values?.phone?.length != 10) {
      return toast.error('Please enter valid phone number.');
    }

    window.scrollTo(0, 0);

    setLoading(true);
    const submitValues = {
      ...values,
      phone: values?.phone,
      pinCode: values?.zipCode,
      isCataloguePurchase,
    };
    setEmailOTP();
    await productSubmitData('orderOTP', '', submitValues)
      .then(res => {
        dispatch(appExtraFunctions('saveActiveStep', 1));
        window.scroll(0, 400);

        if (myDivRef.current) {
          myDivRef.current.scrollIntoView({ behavior: 'smooth' });
        }

        const selectedCategory = cartProducts?.[0]?.category;

        const transportPrice =
          selectedCategory === 'Courses'
            ? 0
            : res?.data?.payload?.shipmentPrice ?? defaultTransportCharges;
        setTransportCharges(transportPrice);
        setEmailOTP(res?.data?.emailOTP);
        setErrorMsg('');
      })
      .catch(err => {
        const msg =
          err?.response?.data?.message ?? 'Error in sending OTP. Please try after sometime.';
        setErrorMsg(msg);
        toast.error(msg);
      });
    setLoading(false);

    dispatch(appExtraFunctions('saveBillingValues', { ...billingValues, otp: '' }));
    setValues({ ...values, otp: '' });
  };

  const handleOTPValidate = async e => {
    e.preventDefault();

    if (values?.otp && values?.otp?.length != 6) {
      return toast.error('Please enter valid OTP.');
    }

    setLoading(true);
    const submitValues = { phone: values?.phone, otp: values?.otp };
    await productSubmitData('validateOrderOTP', '', submitValues)
      .then(() => {
        dispatch(appExtraFunctions('saveActiveStep', 2));
        toast.success('OTP validated successfully.');
      })
      .catch(err => {
        toast.error(err?.response?.data?.message);
      });
    setLoading(false);
  };

  const handleResendOTP = () => {
    const submitValues = { phone: values?.phone };
    dispatch(submitForm('resendOpt', '', submitValues));

    setTimeRemaining(30);

    const timer = setInterval(() => {
      setTimeRemaining(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  return (
    <div>
      <Helmet>
        <script src='https://checkout.razorpay.com/v1/checkout.js'></script>
      </Helmet>

      <AppTitle title={'Checkout'} bgImg={newsLetterBg} from='Cart' to='Checkout' link={'/cart'} />

      <div className='shop-product-section section section-padding-03'>
        <div className='container custom-container'>
          <Box sx={{ width: '100%', transform: { md: 'scale(1.1)' }, mb: 5 }}>
            <Stepper
              activeStep={orderActiveStep}
              sx={{
                '.Mui-completed, .Mui-active': { color: '#b59410 !important' },
              }}
              alternativeLabel
            >
              {steps.map(label => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>

          {orderActiveStep == 0 && (
            <div>
              <form onSubmit={handleBillingAddressSubmit} id='billing-form'>
                <h4 className='mb-4'>Billing Address</h4>

                <div className='row row-cols-sm-2 row-cols-1 g-4'>
                  {billingForm?.map((element, i) => (
                    <div className={element?.name === 'address' ? 'col-sm-12' : 'col'}>
                      {renderElements({ element, setValues, values, handleChange, handleBlur })}
                    </div>
                  ))}
                </div>

                {errorMsg && (
                  <div className='m-2'>
                    <Alert severity='error'>{errorMsg}</Alert>
                  </div>
                )}

                <div className='form-group mb-0 d-flex justify-content-end mt-5 mb-10'>
                  <button
                    className='btn btn-secondary btn-hover-primary'
                    type='submit'
                    disabled={loading}
                  >
                    {loading ? 'Verifying...' : 'Next'}
                  </button>
                </div>
              </form>
            </div>
          )}

          {orderActiveStep == 1 && (
            <div ref={myDivRef}>
              <form onSubmit={handleOTPValidate} id='billing-form'>
                <h4 className='mb-4'>Validate Mobile Number</h4>

                <Alert sx={{ mb: 2 }} severity='warning' color='warning'>
                  An OTP has been sent to your <b>WhatsApp</b> number. To edit your phone number,{' '}
                  <a
                    href='#'
                    style={{ textDecoration: 'underline' }}
                    onClick={() => dispatch(appExtraFunctions('saveActiveStep', 0))}
                  >
                    click here
                  </a>
                  . To resend the SMS to your WhatsApp number,{' '}
                  {/* <a href='#' onClick={handleResendOTP} style={{ textDecoration: 'underline' }}>
                    click here.
                  </a> */}
                  <>
                    {timeRemaining > 0 ? (
                      <span>Wait for {timeRemaining} seconds to resend again.</span>
                    ) : (
                      <a href='#' onClick={handleResendOTP} style={{ textDecoration: 'underline' }}>
                        click here.
                      </a>
                    )}
                  </>
                </Alert>

                <div className='row row-cols-sm-2 row-cols-1  g-4'>
                  {validatePhoneNo?.map((element, i) => (
                    <div className={'col-12'}>
                      {renderElements({ element, setValues, values, handleChange, handleBlur })}
                    </div>
                  ))}
                </div>

                <div className='form-group mb-0 d-flex justify-content-end mt-5 mb-10'>
                  <button
                    className='btn btn-light mx-2'
                    onClick={() => dispatch(appExtraFunctions('saveActiveStep', 0))}
                    type='button'
                  >
                    Prev
                  </button>
                  <button
                    className='btn btn-secondary btn-hover-primary'
                    type='submit'
                    disabled={loading}
                  >
                    {loading ? 'Validating OTP...' : 'Next'}
                  </button>
                </div>
              </form>
            </div>
          )}

          {orderActiveStep === 2 && (
            <>
              <div className='row g-8'>
                {/* <div className='form-group mb-0 d-flex justify-content-start'>
                <button className='btn btn-secondary btn-hover-primary' onClick={handleOpenDialog}>
                  Add Address
                </button>
              </div> */}

                <div className='col-lg-7'>
                  <form onSubmit={handleSubmit} id='billing-form'>
                    <h4 className='mb-4'>Billing Address Details</h4>

                    <Alert sx={{ mb: 2 }} severity='warning' color='warning'>
                      If you would like to edit the billing address, please{' '}
                      <a
                        href='#'
                        style={{ textDecoration: 'underline' }}
                        onClick={() => dispatch(appExtraFunctions('saveActiveStep', 0))}
                      >
                        click here.
                      </a>
                    </Alert>

                    <div className='row row-cols-sm-2 row-cols-1 mt-3 g-4'>
                      {billingForm
                        ?.map(e => ({ ...e, disabled: true }))
                        ?.map((element, i) => (
                          <div className={element?.name === 'address' ? 'col-sm-12' : 'col'}>
                            {renderElements({
                              element,
                              setValues,
                              values,
                              handleChange,
                              handleBlur,
                            })}
                          </div>
                        ))}
                    </div>

                    <div className='form-group mb-0 d-flex justify-content-end mt-3'>
                      {/* <button className='btn btn-secondary btn-hover-primary' type='submit'>
                      Submit
                    </button> */}
                    </div>
                  </form>

                  <div style={{ background: '#e5f6fd', padding: '10px', borderRadius: '5px' }}>
                    {orderNote?.map((element, i) => (
                      <div
                        style={{ minWidth: '100%' }}
                        className={element?.name === 'address' ? 'col-sm-12' : 'col'}
                      >
                        {renderElements({
                          element,
                          setValues,
                          values,
                          handleChange,
                        })}
                      </div>
                    ))}
                  </div>
                </div>

                <div className='col-lg-5'>
                  <div className='checkout-box'>
                    <h4 className='mb-4'>Cart Total</h4>

                    <table className='checkout-summary-table table table-borderless'>
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cartProducts?.map((product, i) => (
                          <tr key={i}>
                            <td>
                              {product?.title} x {product?.quantity}
                            </td>
                            <td>₹{(product?.price * product?.quantity).toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th className='border-top'>Transport charges</th>
                          <th className='border-top'>
                            ₹{transportCharges} * {transportDays}
                          </th>
                        </tr>
                        <tr>
                          <th className='border-top'>Grand Total</th>
                          <th className='border-top'>₹{getOrderSubTotal().toFixed(2)}</th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  {isCataloguePurchase ? (
                    <div className='checkout-box'>
                      <h4 className='mb-4'>Buy Now</h4>
                      <div>
                        <div className='single-method form-check'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            id='accept_terms'
                            checked={agreedTerm}
                            onChange={e => setAgreedTerm(e?.target?.checked)}
                          />
                          <label className='form-check-label' for='accept_terms'>
                            I’ve read and accept the{' '}
                            <a
                              // target='_blanck'
                              className='social-item'
                              // href='/termsAndCondition'
                              href='#'
                              onClick={handleTerms}
                              style={{ textDecoration: 'underline' }}
                            >
                              terms &amp; conditions
                            </a>
                          </label>
                        </div>

                        {values?.email && isCataloguePurchase && (
                          <div className='row'>
                            <div>
                              <Alert severity='info' icon={false}>
                                <span style={{ fontSize: '12px' }}>
                                  An OTP has been sent to your email (
                                  <strong>{values?.email}</strong>).
                                  <br />
                                  Please verify it before completing your purchase.
                                  <br />
                                  If you would like to edit or resend the email, please{' '}
                                  <a
                                    href='#'
                                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                    onClick={e => {
                                      e.preventDefault();
                                      dispatch(appExtraFunctions('saveActiveStep', 0));
                                    }}
                                  >
                                    click here
                                  </a>
                                  .
                                </span>
                              </Alert>
                            </div>
                            {emailOTPForm?.map((element, i) => (
                              <div className={'col-12'}>
                                {renderElements({
                                  element,
                                  setValues,
                                  values,
                                  handleChange,
                                })}
                              </div>
                            ))}
                          </div>
                        )}

                        <button
                          className='btn btn-dark btn-hover-primary btn-block rounded-0 mt-4'
                          disabled={btnLoaderOne ? true : !agreedTerm}
                          onClick={handlePlaceOrder}
                        >
                          {btnLoaderOne ? 'Please wait...' : 'Buy Now'}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className='checkout-box'>
                      <div>
                        <h4 className='mb-4'>Delivery Timings</h4>

                        <p className='mb-2'>Choose your preferred delivery time.</p>
                        <div className='checkout-payment-method'>
                          {deliveryTimeSlots?.map((slots, i) => (
                            <div className='single-method form-check' key={i}>
                              <input
                                className='form-check-input'
                                type='radio'
                                id={`${deliveryTimeSlots}_${i}`}
                                onChange={e => handleTimeSlotsChange(e, slots)}
                                // value={paymentMethod}
                                name={'deliveryTimeSlots'}
                              />
                              <label className='form-check-label' for={`${deliveryTimeSlots}_${i}`}>
                                {convertTo12HourFormat(slots[0])} -{' '}
                                {convertTo12HourFormat(slots[1])}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <hr />
                      <h4 className='mb-4'>Payment Method</h4>

                      <div className='checkout-payment-method'>
                        {paymentMethods?.map((method, i) => (
                          <div className='single-method form-check' key={i}>
                            <input
                              className='form-check-input'
                              type='radio'
                              id={method}
                              onChange={e => handlePaymentChoose(e, method)}
                              // value={paymentMethod}
                              name={'payment-method'}
                            />
                            <label className='form-check-label' for={method}>
                              {method}
                            </label>
                          </div>
                        ))}

                        <div className='single-method form-check'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            id='accept_terms'
                            checked={agreedTerm}
                            onChange={e => setAgreedTerm(e?.target?.checked)}
                          />
                          <label className='form-check-label' for='accept_terms'>
                            I’ve read and accept the{' '}
                            <Link
                              className='social-item'
                              to='#'
                              onClick={handleTerms}
                              style={{ textDecoration: 'underline' }}
                            >
                              terms &amp; conditions
                            </Link>
                          </label>
                        </div>
                      </div>

                      <button
                        className='btn btn-dark btn-hover-primary rounded-0 mt-6'
                        disabled={
                          btnLoaderOne ? true : !paymentMethod || !agreedTerm || !deliverySlots
                        }
                        onClick={handlePlaceOrder}
                      >
                        {btnLoaderOne ? 'Please wait...' : 'Place order'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <AppDialogBox
        title={'Terms & Conditions'}
        size={'lg'}
        open={showDialog}
        setOpen={setShowDialog}
        disableBackdropClick={false}
      >
        <TermsAndConditions showTitle={false} />
      </AppDialogBox>
    </div>
  );
};

export default Checkout;
